
<!-- 产品展示页 -->
<template>
    <div class="content">
        <navigator v-if="!isPhone">
            <div class="navTitle box">
                <div @click="openRegister">注册&nbsp;</div>&nbsp;|&nbsp;<div @click="openLogin">&nbsp;登录</div>
            </div>
        </navigator>
        <banner @onRegister="openRegister"></banner>
        <project-list :datalist='projectarr'></project-list>
        <product-info :isPhone="isPhone"></product-info>
        <platform-advantage  :isPhone="isPhone"></platform-advantage>
        <service :isPhone="isPhone"></service>
        <contact :isPhone="isPhone"></contact>
        <trials v-if="!isPhone"></trials>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import navigator from "../../components/navigator";
import banner from './components/banner'
import projectList from './components/projectList'
import productInfo from './components/productInfo'
import platformAdvantage from './components/platformAdvantage'
import service from './components/service'
import contact from './components/contact'
import trials from './components/trials'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        navigator,
        banner,
        projectList,
        productInfo,
        platformAdvantage,
        service,
        contact,
        trials
    },
    data() {
    //这里存放数据
        return {
            isPhone:false,
            projectarr:[{
                logo:require('../../assets/images/showProduct/logo1.png'),
                address:"北京市西城区",
                name:"月坛街道"
            },{
                logo:require('../../assets/images/showProduct/logo2.png'),
                address:"北京市朝阳区",
                name:"孙河乡"
            },{
                logo:require('../../assets/images/showProduct/logo3.png'),
                address:"北京市丰台区",
                name:"南苑乡"
            },{
                logo:require('../../assets/images/showProduct/logo4.png'),
                address:"北京市西城区",
                name:"广外街道"
            },{
                logo:require('../../assets/images/showProduct/logo5.png'),
                address:"北京市门头沟区",
                name:"东辛房街道"
            }]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        openLogin(){
            //打开登录
            this.$router.push({ name: "NewLogin"});
        },
        openRegister(){
             //打开注册
            this.$router.push({ name: "NewLogin"});
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        var deviceWidth = document.documentElement.clientWidth;
        if(parseInt(deviceWidth)<540) this.isPhone=true
        var docEl=document.documentElement;         //documentElement 属性是根节点
        docEl.style.fontSize = 30 * (deviceWidth / 750) + 'px';//设置html根元素的font-size

        this.$store.commit("updateNavText","")
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {
        console.log('[sys] showProduct destroyed');
        this.$store.commit("updateNavText","")
    }, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style src="./pc.css" scoped></style>
<style src="./phone.css" scoped></style>
